import React, { useEffect } from 'react'
import aos from "aos";
import "aos/dist/aos.css";

const About = () => {

    useEffect(() => {
        aos.init({ duration: 2000 });
      }, []);


    document.title ="💻 About | Rian Islam"
    return (

        <div className="container">
        <div className="row py-5">
            <div className="col-md-2"></div>
            <div className="col-md-8 py-5">
                <h1 data-aos="fade-right" className="pt-4">About Rian Islam</h1>
              <p data-aos="fade-left" className="pb-3">I'm a CS background Student, Curious about Web Application Development, and Security.
              Expertise in developing Web Application using HTML5, CSS3, Javascript, ES6, ReactJs,NodeJs,Express,MongoDB.</p>
                <p data-aos="fade-right">I'm a full-time Coder.In 2019,My current focus is on Backend development with Node.js and Python.I actively working for my Skill,doing some projects</p>
            
            <div data-aos="fade-left">
            <h1 className="pt-4">Education</h1>
            <h3>Degree</h3>
            <li><p>Bsc in Computer Science and Engineering(2019-at Present)</p></li>
            </div>


            <div data-aos="fade-right">
            <h1 className="pt-4">Certifications</h1>
            
            <li><p>Loading...</p></li>
            </div>


            <div data-aos="fade-left">
            <h1 className="pt-4">Hobbies</h1>
            <li><p>Play(Cricket,Football)</p></li>
            <li><p>Learning Coding</p></li>
            <li><p>Photography</p></li>
            </div>

            <div data-aos="fade-right">

            <h3 className="py-3">Links</h3>
            <li><a target="_blank" href="https://drive.google.com/file/d/1ICbuanBndVuiICkl9kzv7LdLpz0mSdzh/view">Resume</a></li>
            <li><a target="_blank" href="https://twitter.com/rianislam0or_">Twitter</a></li>
            <li><a target="_blank" href="https://github.com/RianIslam">Github</a></li>
            <li><a target="_blank" href="https://www.linkedin.com/in/rian-islam/">LinkedIn</a></li>

            </div>  
           


            </div>
            <div className="col-md-2"></div>
            </div>
        </div>
    )
}

export default About
